<template>
    <div class="m-auto px-8 md:px-20">
        <div class="max-w-screen-2xl m-auto">
            <div class="py-5 flex justify-between">
                <h1 class="text-2xl font-bold">Previsionale commerciale</h1>

                <NextButton component="router-link" :to="{name:'CreaBilancioPrevisionale'}"
                            class="py-1 px-3">
                    Nuovo
                </NextButton>
            </div>
            <div class="grid grid-cols-3 gap-3">
                <div class="flex flex-col">
                    <Field @update:modelValue="search" v-model="lista.search" field_name="Cerca"
                           placeholder="Cerca"></Field>
                </div>

                <div class="flex flex-col">
                    <Field field_name="Business unit"
                           placeholder="Business unit">

                        <VueMultiselect :searchable="true" :loading="buAutocomplete.isLoading"
                                        :internal-search="false"
                                        trackBy="id"
                                        label="label"
                                        @search-change="buAutocomplete.search"
                                        v-model="buAutocomplete.selection"
                                        :options="buAutocomplete.options"
                                        @update:modelValue="search"
                                        :multiple="true"
                                        :close-on-select="false" :clear-on-select="false"
                                        class="next-vue-multiselect"
                                        placeholder="Business Unit"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona"
                        >
                            <template v-slot:tag="{option, remove}">
                                <MultiselectOption @remove="remove(option)">
                                    <span class="border text-xs border-next-dark-gray px-2 rounded-sm mr-2">
                                        {{ option.label || '&nbsp;' }}</span>
                                    <span>{{ option.nome }}</span>
                                </MultiselectOption>
                            </template>
                            <template v-slot:option="{option, props}">
                                <span
                                    class="relative inline-block p-2 group">
                                    <span class="mr-2 border border-next p-1">{{ option.label }}</span><span
                                    class="mr-1">{{ option.nome }}</span>
                                </span>
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>

                <div class="flex flex-col">
                    <Field @update:modelValue="search" v-model="filtro_anno" field_name="Anno" type="number"
                           placeholder="Anno"></Field>
                </div>
            </div>
            <div class="flex justify-end">
                <Paginator class="" :pagination="lista.paginate"></Paginator>
            </div>
            <div class="rotate-x-180 overflow-x-scroll">
                <NextTable class="rotate-x-180 table-auto w-full border-separate border-spacing-3 py-4"
                           v-model:cols="cols"
                           :rows="lista.rows" @order-update="lista.updateCols">

                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_3`]="{context}">
                        {{ $filters.toEuroCurrency(context.row.previsto) }}
                    </template>

                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_4`]="{context}">
                        {{ $filters.toEuroCurrency(context.row.progresso) }}
                    </template>

                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_5`]="context">
                        <router-link
                            :to="{name:'DettaglioBilancioPrevisionale', params:{id:context.context.row.business_unit_id, bid:context.context.row.id}}"
                            class="text-center inset-0 absolute flex items-center justify-center"><i
                            class="icon-chevron_destra"></i></router-link>
                    </template>
                </NextTable>
            </div>
            <InfiniteLoading @infinite="lista.fetchNextPage"
                             :identifier="lista.infiniteIdentifier" style="min-height: 1px">
                <template #complete>
                    <div class="text-center pb-3">Non ci sono altre attività.</div>
                </template>
            </InfiniteLoading>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import NextTable from "@/components/NextTable.vue";
import InfiniteLoading from "v3-infinite-loading";
import Loading from "@/components/Loading.vue";
import Field from "@/components/Field.vue";
import Lista from "@/setup/ListaCerca";
import Paginator from "@/components/Paginator.vue";
import NextButton from "@/components/NextButton.vue";
import bilanciPrevisionaliManager from "@/api/BilanciPrevisionaliManager";
import MultiselectOption from "@/components/MultiselectOption.vue";
import Autocomplete from "@/setup/Autocomplete";
import businessUnitsManager from "@/api/BusinessUnits";

@Options({
    name: 'BilanciPrevisionali',
    components: {
        MultiselectOption,
        NextButton,
        Paginator,
        Loading,
        Field,
        NextTable,
        InfiniteLoading
    }
})
export default class BilanciPrevisionali extends Vue {
    lista: any = setup(() => Lista(bilanciPrevisionaliManager, this.cols));
    buAutocomplete: any = setup(() => Autocomplete(businessUnitsManager, true))
    visible = false

    filtro_anno = null

    created() {
        this.lista.reset()
    }

    search() {
        this.$nextTick(() => {
            this.lista.apiParams = {
                anno: this.filtro_anno,
                bu: this.buAutocomplete.selection.map((e: any) => e.id)
            }
            this.lista.debounceSearch()
        })
    }


    cols = [
        {
            name: 'Cliente',
            prop: 'cliente.denominazione',
            orderable: true,
            ordProp: 'anagrafiche_denominazioni.denominazione',
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Business Unit',
            prop: 'business_unit.nome',
            orderable: true,
            ordProp: 'business_units.nome',
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Anno',
            prop: 'anno',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Bilancio previsionale',
            prop: 'previsto',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'text-right px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Progresso',
            prop: 'progresso',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'text-right px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative bg-next-gray-md-dark hover:bg-next-orange hover:text-white',
            resizable: false
        }
    ]
}

</script>


<style lang="scss">

</style>
